const header = document.querySelector(".header");

if (header) {
	const burger = header.querySelector(".header__nav-burger");
	const navContainer = header.querySelector(".header__nav-container");

	const setMenu = (open) => {
		burger?.classList.toggle("active", open);
		navContainer?.classList.toggle("active", open);
		document.body.classList.toggle("no-scroll", open);
		if (window.lenis) open ? window.lenis.stop() : window.lenis.start();
	};

	burger?.addEventListener("click", () => {
		setMenu(!burger.classList.contains("active"));
	});

	window.matchMedia("(min-width: 1440px)").addEventListener("change", () => setMenu(false));

	// Тоггл выпадающего списка языков/стран
	header.querySelectorAll(".header-lang-switcher").forEach((switcher) => {
		const toggler = switcher.querySelector(".header-lang-switcher__toggler");
		const list = switcher.querySelector(".header-lang-switcher__list");
		if (!toggler || !list) return;

		toggler.addEventListener("click", (e) => {
			e.stopPropagation();
			list.classList.toggle("active");
		});
	});

	// Закрываем по клику вне свитчера
	document.addEventListener("click", (e) => {
		if (e.target.closest(".header-lang-switcher")) return;
		header.querySelectorAll(".header-lang-switcher__list.active")
			.forEach((list) => list.classList.remove("active"));
	});

	let lastScrollY = window.scrollY;

	window.addEventListener("scroll", () => {
		if (burger?.classList.contains("active")) return;

		const currentY = window.scrollY;
		const headerH = header.offsetHeight;

		if (currentY > headerH && currentY > lastScrollY) {
			header.classList.add("hidden");
		} else if (currentY < lastScrollY) {
			header.classList.remove("hidden");
		}

		lastScrollY = currentY;
	}, { passive: true });
}
